import { render, staticRenderFns } from "./MyBetgames.vue?vue&type=template&id=4248d76f&scoped=true"
import script from "./MyBetgames.vue?vue&type=script&lang=js"
export * from "./MyBetgames.vue?vue&type=script&lang=js"
import style0 from "./MyBetgames.vue?vue&type=style&index=0&id=4248d76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4248d76f",
  null
  
)

export default component.exports